import { FileUploadRow } from "features/shared/components/FileUploadRow";
import { useTranslation } from "react-i18next";

import { EpcFileUploadBase } from "./EpcFileUploadBase";

type EpcUploadingPhaseProps = {
  file: File;
  uploadProgress: null | number;
};

export const EpcUploadingPhase = ({ file, uploadProgress }: EpcUploadingPhaseProps) => {
  const { t } = useTranslation();
  return (
    <EpcFileUploadBase
      file={file}
      message={t("AddBuilding.epcModal.uploadingMessage")}
      progressComponent={
        <FileUploadRow
          fileSize={file.size}
          indicatorWidthClassName="w-full"
          showPercentage
          step={{ name: "", percentage: uploadProgress ?? 0, status: undefined }}
        />
      }
      title={t("AddBuilding.epcModal.uploadingTitle")}
    />
  );
};
